var splats = [];
var splatItemClass = "adquick-item-homepage";
var productImageRegex = /\/\/cdn.shopify.com\/s\/files\/[0-9\/]*\/products\//;
// splats.push({
//   type: "collection",
//   handle: "aliendildo",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/dildos",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/168/original/pitch-grafik_Dildos.avif?1647611140",
// });
// splats.push({
//   type: "collection",
//   handle: "",
//   position: 99,
//   show_on_all_pages: true,
//   show_on_tag_filtered_pages: true,
//   link: "/pages/10-gruende",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/233/original/10_Gute_Gr%C3%BCnde_bzw._Marielove_Marielove_Dolls_Vorteile.png?1691745020",
// });
// splats.push({
//   type: "collection",
//   handle: "",
//   position: 99,
//   show_on_all_pages: true,
//   show_on_tag_filtered_pages: true,
//   link: "/pages/diskreter-versand",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/159/original/diskreter_Versand_Kachel_%281%29.avif?1646412048",
// });
// splats.push({
//   type: "collection",
//   handle: "",
//   position: 18,
//   show_on_all_pages: true,
//   show_on_tag_filtered_pages: true,
//   link: "https://www.marielove.de/policies/shipping-policy",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/161/original/0_euro_versand.avif?1646412083",
// });
// splats.push({
//   type: "collection",
//   handle: "",
//   position: 22,
//   show_on_all_pages: true,
//   show_on_tag_filtered_pages: true,
//   link: "https://www.marielove.de/policies/refund-policy",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/160/original/30_tage_r%C3%BCckgabe.avif?1646412070",
// });
// splats.push({
//   type: "collection",
//   handle: "",
//   position: 24,
//   show_on_all_pages: true,
//   show_on_tag_filtered_pages: true,
//   link: "/pages/sicher-bezahlen",
//   url: "https://cdn.shopify.com/s/files/1/0273/0603/3289/files/Zahlungsmethoden-Pitch-Grafik_2.webp?v=1732298001",
// });
// splats.push({
//   type: "collection",
//   handle: "",
//   position: 28,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "https://cdn.shopify.com/s/files/1/0273/0603/3289/files/flotter-dreier.png?v=1743363579",
// });
// splats.push({
//   type: "collection",
//   handle: "",
//   position: 32,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.trustami.com/erfahrung/marielove-fuer-neuen-schwung-bewertung",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/157/original/positive_Bewertungen.avif?1646412020",
// });
splats.push({
  type: "index",
  handle: "index",
  position: 99,
  show_on_all_pages: false,
  show_on_tag_filtered_pages: false,
  link: "/pages/10-gruende",
  url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/233/original/10_Gute_Gr%C3%BCnde_bzw._Marielove_Marielove_Dolls_Vorteile.png?1691745020",
});
splats.push({
  type: "index",
  handle: "index",
  position: 99,
  show_on_all_pages: false,
  show_on_tag_filtered_pages: true,
  link: "/pages/diskreter-versand",
  url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/159/original/diskreter_Versand_Kachel_%281%29.avif?1646412048",
});
// splats.push({
//   type: "index",
//   handle: "index",
//   position: 8,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: true,
//   link: "https://www.marielove.de/policies/shipping-policy",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/161/original/0_euro_versand.avif?1646412083",
// });
// splats.push({
//   type: "index",
//   handle: "index",
//   position: 12,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: true,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/160/original/30_tage_r%C3%BCckgabe.avif?1646412070",
// });
// splats.push({
//   type: "index",
//   handle: "index",
//   position: 14,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: true,
//   link: "/pages/sicher-bezahlen",
//   url: "https://cdn.shopify.com/s/files/1/0273/0603/3289/files/Zahlungsmethoden-Pitch-Grafik_2.webp?v=1732298001",
// });
// splats.push({
//   type: "index",
//   handle: "index",
//   position: 18,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "https://cdn.shopify.com/s/files/1/0273/0603/3289/files/flotter-dreier.png?v=1743363579",
// });
// splats.push({
//   type: "index",
//   handle: "index",
//   position: 22,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.trustami.com/erfahrung/marielove-fuer-neuen-schwung-bewertung",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/157/original/positive_Bewertungen.avif?1646412020",
// });
// splats.push({
//   type: "collection",
//   handle: "liebespuppen-sonderaktion",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/185/original/automatischer-masturbator.gif?1648824945",
// });
// splats.push({
//   type: "collection",
//   handle: "analhaken",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/analtoys",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/179/original/analtoys_pitch.avif?1648738627",
// });
// splats.push({
//   type: "collection",
//   handle: "automatischer-masturbator",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/masturbator-heizstab",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/198/original/heizstab_%281%29.avif?1651827514",
// });
// splats.push({
//   type: "collection",
//   handle: "brustpumpen",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/bondage-sets",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/188/original/bondage_sets.avif?1649258297",
// });
// splats.push({
//   type: "collection",
//   handle: "doppel-strapon",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/strapon",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/175/original/strap_on_pitch.png?1647867807",
// });
// splats.push({
//   type: "collection",
//   handle: "doppelvibrator",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/vibratoren",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/200/original/Vibratoren-w.avif?1655995656",
// });
// splats.push({
//   type: "collection",
//   handle: "dragon-dildo",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/dildos",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/168/original/pitch-grafik_Dildos.avif?1647611140",
// });
// splats.push({
//   type: "collection",
//   handle: "druckwellenvibrator",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/vibratoren",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/200/original/Vibratoren-w.avif?1655995656",
// });
// splats.push({
//   type: "collection",
//   handle: "fingervibrator",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/vibratoren",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/200/original/Vibratoren-w.avif?1655995656",
// });
// splats.push({
//   type: "collection",
//   handle: "gummimuschi",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/taschenmuschi",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/178/original/taschenmuschi_pitch.avif?1647881543",
// });
// splats.push({
//   type: "collection",
//   handle: "gummimuschi",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/masturbator-heizstab",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/198/original/heizstab_%281%29.avif?1651827514",
// });
// splats.push({
//   type: "collection",
//   handle: "hodenvibrator",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/penisring",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/191/original/cockringe.avif?1651753782",
// });
// splats.push({
//   type: "collection",
//   handle: "klitorisvibrator",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/vibratoren",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/200/original/Vibratoren-w.avif?1655995656",
// });
// splats.push({
//   type: "collection",
//   handle: "kuenstlicher-penis",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/dildos",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/168/original/pitch-grafik_Dildos.avif?1647611140",
// });
// splats.push({
//   type: "collection",
//   handle: "kuenstliche-vagina",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/taschenmuschi",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/178/original/taschenmuschi_pitch.avif?1647881543",
// });
// splats.push({
//   type: "collection",
//   handle: "kuenstliche-vagina",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/masturbator-heizstab",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/198/original/heizstab_%281%29.avif?1651827514",
// });
// splats.push({
//   type: "collection",
//   handle: "lush-vibrator",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/vibratoren",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/200/original/Vibratoren-w.avif?1655995656",
// });
// splats.push({
//   type: "collection",
//   handle: "magic-wand",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/magicwand-aufsatz",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/173/original/Aufsatz_Pitch_%281%29.avif?1647865090",
// });
// splats.push({
//   type: "collection",
//   handle: "massagestab",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/magicwand-aufsatz",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/173/original/Aufsatz_Pitch_%281%29.avif?1647865090",
// });
// splats.push({
//   type: "collection",
//   handle: "liebespuppen-sonderaktion",
//   position: 17,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/masturbatoren",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/181/original/masturbatoren.avif?1648813571",
// });
// splats.push({
//   type: "collection",
//   handle: "masturbator-torso",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/masturbator-heizstab",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/198/original/heizstab_%281%29.avif?1651827514",
// });
// splats.push({
//   type: "collection",
//   handle: "penisring-mit-vibration",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/penisring",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/191/original/cockringe.avif?1651753782",
// });
// splats.push({
//   type: "collection",
//   handle: "prostata-dildo",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/dildos",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/168/original/pitch-grafik_Dildos.avif?1647611140",
// });
// splats.push({
//   type: "collection",
//   handle: "prostata-dildo",
//   position: 16,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/analplug",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/196/original/analplug.png?1651764722",
// });
// splats.push({
//   type: "collection",
//   handle: "sexpuppen-torso",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/masturbator-heizstab",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/198/original/heizstab_%281%29.avif?1651827514",
// });
// splats.push({
//   type: "collection",
//   handle: "sexspielzeug-bis-25-euro",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/190/original/gleitgel-kachel.png?1651749260",
// });
// splats.push({
//   type: "collection",
//   handle: "sexspielzeug-bis-25-euro",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/193/original/sextoyset.avif?1651758790",
// });
// splats.push({
//   type: "collection",
//   handle: "sexspielzeug-bis-25-euro",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/194/original/sexschaukel-kachel_%281%29.avif?1651760644",
// });
// splats.push({
//   type: "collection",
//   handle: "sexspielzeug-bis-25-euro",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/195/original/sexmaschine.gif?1651763856",
// });
// splats.push({
//   type: "collection",
//   handle: "sexspielzeug-bis-25-euro",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/196/original/analplug.png?1651764722",
// });
// splats.push({
//   type: "collection",
//   handle: "sexspielzeug-bis-25-euro",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/198/original/heizstab_%281%29.avif?1651827514",
// });
// splats.push({
//   type: "collection",
//   handle: "sexspielzeug-bis-25-euro",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/199/original/sexdolltorso.png?1651846845",
// });
// splats.push({
//   type: "collection",
//   handle: "sexspielzeug-bis-25-euro",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/192/original/penispumpe-kachel.avif?1651756391",
// });
// splats.push({
//   type: "collection",
//   handle: "sexspielzeug-bis-25-euro",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/185/original/automatischer-masturbator.gif?1648824945",
// });
// splats.push({
//   type: "collection",
//   handle: "sexspielzeug-bis-25-euro",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/182/original/dilatoren.png?1648813845",
// });
// splats.push({
//   type: "collection",
//   handle: "sexspielzeug-bis-25-euro",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/181/original/masturbatoren.avif?1648813571",
// });
// splats.push({
//   type: "collection",
//   handle: "sexspielzeug-bis-25-euro",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/180/original/vibrator_eier.avif?1648739852",
// });
// splats.push({
//   type: "collection",
//   handle: "sexspielzeug-bis-25-euro",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/179/original/analtoys_pitch.avif?1648738627",
// });
// splats.push({
//   type: "collection",
//   handle: "sexspielzeug-bis-25-euro",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/178/original/taschenmuschi_pitch.avif?1647881543",
// });
// splats.push({
//   type: "collection",
//   handle: "sexspielzeug-bis-25-euro",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/175/original/strap_on_pitch.png?1647867807",
// });
// splats.push({
//   type: "collection",
//   handle: "sexspielzeug-bis-25-euro",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/173/original/Aufsatz_Pitch_%281%29.avif?1647865090",
// });
// splats.push({
//   type: "collection",
//   handle: "sexspielzeug-bis-25-euro",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/168/original/pitch-grafik_Dildos.avif?1647611140",
// });
// splats.push({
//   type: "collection",
//   handle: "sexspielzeug-bis-25-euro",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/186/original/dildo_vibratorn.avif?1649087727",
// });
// splats.push({
//   type: "collection",
//   handle: "sexspielzeug-bis-25-euro",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/187/original/paarvibratoren.avif?1649088450",
// });
// splats.push({
//   type: "collection",
//   handle: "sexspielzeug-bis-25-euro",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/188/original/bondage_sets.avif?1649258297",
// });
// splats.push({
//   type: "collection",
//   handle: "sexspielzeug-bis-25-euro",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/189/original/Estim.avif?1651748018",
// });
// splats.push({
//   type: "collection",
//   handle: "sexspielzeug-bis-25-euro",
//   position: 12,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/184/original/magic_wand_vibratoren.avif?1648822542",
// });
// splats.push({
//   type: "collection",
//   handle: "sexspielzeug-bis-25-euro",
//   position: 13,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/183/original/bondage_fesseln.avif?1648814201",
// });
// splats.push({
//   type: "collection",
//   handle: "stossvibrator",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/vibratoren",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/200/original/Vibratoren-w.avif?1655995656",
// });
// splats.push({
//   type: "collection",
//   handle: "strap-on-hohl",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/strapon",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/175/original/strap_on_pitch.png?1647867807",
// });
// splats.push({
//   type: "collection",
//   handle: "taschenmuschi",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/masturbator-heizstab",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/198/original/heizstab_%281%29.avif?1651827514",
// });
// splats.push({
//   type: "collection",
//   handle: "taschenmuschi",
//   position: 10,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/masturbatoren",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/181/original/masturbatoren.avif?1648813571",
// });
// splats.push({
//   type: "collection",
//   handle: "umschnalldildo",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/strapon",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/175/original/strap_on_pitch.png?1647867807",
// });
// splats.push({
//   type: "collection",
//   handle: "vibrating-strapon",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/strapon",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/175/original/strap_on_pitch.png?1647867807",
// });
// splats.push({
//   type: "collection",
//   handle: "vibrator-mit-fernbedienung",
//   position: 11,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/vibratoren",
//   url: "//s3.amazonaws.com/clean-themes-splat/saved_splats/files/000/001/200/original/Vibratoren-w.avif?1655995656",
// });
// splats.push({
//   type: "page",
//   handle: "metalp",
//   position: 31,
//   show_on_all_pages: false,
//   show_on_tag_filtered_pages: false,
//   link: "https://www.marielove.de/collections/masturbatoren",
//   url: "https://cdn.shopify.com/s/files/1/0273/0603/3289/files/automatischer-simulatoren_LP.gif?v=1734677938",
// });
// specific implementations of collections
// note: using jQuery inside these should be OK, if the theme uses a global copy
var knownImplementationPatterns = [
  // Showcase - using columns
  {
    useThisPattern: function () {
      return !!document.querySelector(
        "#page-content .product-list.jiggly-split > .column"
      );
    },
    addSplat: function (splat) {
      // set data for future reflows
      var productBlocks = document.querySelectorAll(
        "#page-content .product-list .product-block"
      );
      for (var i = 0; i < productBlocks.length; i++) {
        // must use jQuery data instead of dataset, in this theme
        var intLoopIndex = parseInt($(productBlocks[i]).data("loop-index"));
        if (intLoopIndex >= splat.position) {
          $(productBlocks[i]).data("loop-index", intLoopIndex + 1);
        }
      }
      // create element and set loopIndex data
      var splatContainer = createElement(
        "div",
        "product-block " + splatItemClass
      );
      splatContainer.dataset.loopIndex = splat.position;
      addSplatAcrossMultipleContainers(
        document.querySelectorAll(
          "#page-content .product-list.jiggly-split > .column"
        ),
        splatContainer,
        splat
      );
    },
  },
  // Showcase - using grid
  {
    useThisPattern: function () {
      var el = document.querySelector(
        "#page-content .wide-container.double-gutter .product-list"
      );
      return el && el.className.indexOf("jiggly-split") < 0;
    },
    addSplat: function (splat) {
      // detect the sizing
      var perRow = 4;
      var layoutClass = "quarter";
      if ($("#page-content .product-list .product-block.third:first").length) {
        perRow = 3;
        layoutClass = "third";
      } else if (
        $("#page-content .product-list .product-block.half:first").length
      ) {
        perRow = 2;
        layoutClass = "half";
      }
      // add the splat
      addSplatToContainer(
        splat,
        $("#page-content .product-list")[0],
        createElement(
          "div",
          "product-block column " + splatItemClass + " " + layoutClass
        ),
        splat.position
      );
      // redo clearing divs
      $("#page-content .product-list .er").remove();
      $(
        "#page-content .product-list .product-block:nth-child(" + perRow + "n)"
      ).after('<div class="er">');
    },
  },
  // Showcase - mobile masonry
  {
    useThisPattern: function () {
      return !!document.querySelector(
        "#page-content .wide-container.double-gutter .product-list.jiggly-split > .product-block"
      );
    },
    addSplat: function (splat) {
      var splatContainer = attemptWithGenericPattern(splat);
      if (splatContainer) {
        var count = 1;
        for (
          var i = 0;
          i < splatContainer.parentElement.childNodes.length;
          i++
        ) {
          var el = splatContainer.parentElement.childNodes[i];
          if (el.tagName) {
            el.dataset["loopIndex"] = count++;
          }
        }
      }
    },
  },
  // Expression
  {
    useThisPattern: function () {
      return !!document.querySelector(
        "#wrap #content .productlist .product .imagecontainer"
      );
    },
    addSplat: function (splat) {
      // create splat
      var el = createElement("div", "product " + splatItemClass);
      // add elements that are used in height normalisation
      var heightFudge = createElement("div", "");
      heightFudge.style.display = "none";
      heightFudge.appendChild(createElement("div", "imagecontainer"));
      heightFudge.appendChild(createElement("div", "title"));
      el.appendChild(heightFudge);
      // add to page
      addSplatToContainerWithFirstLastClear(
        "#wrap #content .productlist",
        "#wrap #content .productlist .product",
        el,
        splat,
        false,
        "last"
      );
      // trigger a reassessment of heights
      $(window).trigger("forceproductblockheights");
    },
  },
  // Alchemy
  {
    useThisPattern: function () {
      return !!document.querySelector(
        "#main .product-list.grid .prod-block .prod-image-wrap"
      );
    },
    addSplat: function (splat) {
      // add .prod-caption to splat container
      var productBlock = document.querySelector(
        "#main .product-list.grid .prod-block"
      );
      var splatEl = createElement(
        "div",
        productBlock.className + " " + splatItemClass
      );
      splatEl.innerHTML =
        '<div class="prod-caption" style="display:none"></div>';
      // add the splat
      addSplatToContainer(
        splat,
        document.querySelector("#main .product-list"),
        splatEl,
        splat.position
      );
      // redo clearing divs
      var perRow = 5;
      if (productBlock.className.indexOf("quarter") > -1) {
        perRow = 4;
      } else if (productBlock.className.indexOf("third") > -1) {
        perRow = 3;
      } else if (productBlock.className.indexOf("half") > -1) {
        perRow = 2;
      }
      $("#main .product-list.grid .prod-block.first-in-row").removeClass(
        "first-in-row"
      );
      $(
        "#main .product-list.grid .prod-block:nth-child(" + perRow + "n+1)"
      ).addClass("first-in-row");
      $(window).trigger("resize");
    },
  },
  // Symmetry
  {
    useThisPattern: function () {
      return !!document.querySelector(
        "#content .collection-listing .product-list .product-block .block-inner .product-link"
      );
    },
    addSplat: function (splat) {
      var productBlock = document.querySelector(
        "#content .collection-listing .product-list .product-block"
      );
      // grid/stream toggle clears opacity - so we need to add the 'main-image-loaded' class
      var splatEl = createElement(
        "div",
        productBlock.className + " main-image-loaded " + splatItemClass
      );
      // add the splat
      addSplatToContainer(
        splat,
        document.querySelector("#content .collection-listing .product-list"),
        splatEl,
        splat.position
      );
    },
  },
  // Canopy - with old grid css
  {
    useThisPattern: function () {
      return !!document.querySelector(
        "#collection .product-list.row.grid .product-block.nth-2"
      );
    },
    addSplat: function (splat) {
      attemptWithGenericPattern(splat);
      // reset nth-child classes
      var productContainers = document.querySelectorAll(
        "#collection .product-list .product-block"
      );
      for (var i = 0; i < productContainers.length; i++) {
        removeClassFromElement(productContainers[i], "nth-[0-9]");
        if (i % 2 == 0) {
          productContainers[i].className =
            productContainers[i].className + " nth-2";
        }
        if (i % 3 == 0) {
          productContainers[i].className =
            productContainers[i].className + " nth-3";
        }
        if (i % 4 == 0) {
          productContainers[i].className =
            productContainers[i].className + " nth-4";
        }
        if (i % 6 == 0) {
          productContainers[i].className =
            productContainers[i].className + " nth-6";
        }
      }
    },
  },
  // Narrative
  {
    useThisPattern: function () {
      return !!document.querySelector(
        ".data-animations .collection-template .card-list .card-list__column"
      );
    },
    addSplat: function (splat) {
      addSplatAcrossMultipleContainers(
        document.querySelectorAll(
          ".collection-template .card-list .card-list__column"
        ),
        createElement("div", "card card--reveal " + splatItemClass),
        splat
      );
    },
  },
  // Atlantic - with quick-buy
  {
    useThisPattern: function () {
      return !!document.querySelector(
        ".product-list li.product .quick-shop-content"
      );
    },
    addSplat: function (splat) {
      var splatContainer = createElement("li", "product " + splatItemClass);
      addSplatToContainer(
        splat,
        document.querySelector(".product-list"),
        splatContainer,
        splat.position
      );
    },
  },
  // Split - with a large collection box
  {
    useThisPattern: function () {
      return !!document.querySelector(
        "#section-collection.site-box-container .site-box.box--big"
      );
    },
    addSplat: function (splat) {
      // how many large boxes?
      var largeBoxes = document.querySelectorAll(
        "#section-collection.site-box-container .site-box.box--big"
      );
      var splatContainer = createElement(
        "div",
        "site-box box--small box--typo-small lap--box--small-lg " +
          splatItemClass
      );
      addSplatToContainer(
        splat,
        document.querySelector(".site-box-container"),
        splatContainer,
        splat.position + largeBoxes.length
      );
    },
  },
  // Icon
  {
    useThisPattern: function () {
      return !!document.querySelector("#product-loop .product.first");
    },
    addSplat: function (splat) {
      var firstProduct = document.querySelector("#product-loop .product");
      addSplatToContainerWithFirstLastClear(
        "#product-loop",
        "#product-loop .product",
        createElement("div", firstProduct.className + " " + splatItemClass),
        splat,
        "first",
        "last"
      );
    },
  },
  // Testament & Mr Parker
  {
    useThisPattern: function () {
      return !!document.querySelector("#product-loop .product-index.first");
    },
    addSplat: function (splat) {
      var firstProduct = document.querySelector("#product-loop .product-index");
      addSplatToContainerWithFirstLastClear(
        "#product-loop",
        "#product-loop .product-index",
        createElement("div", firstProduct.className + " " + splatItemClass),
        splat,
        "first",
        "last"
      );
    },
  },
  // Blockshop
  {
    useThisPattern: function () {
      return !!document.querySelector(".product-grid .clearfix");
    },
    addSplat: function (splat) {
      var firstProduct = document.querySelector(".product-grid .product-item");
      addSplatToContainerWithFirstLastClear(
        ".product-grid",
        ".product-grid .product-item",
        createElement("div", firstProduct.className + " " + splatItemClass),
        splat,
        false,
        false,
        createElement("div", "clearfix")
      );
    },
  },
  // Colors
  {
    useThisPattern: function () {
      return !!document.querySelector(
        ".collection .inner .collection-products > div .collection-product.col-0"
      );
    },
    addSplat: function (splat) {
      var firstProduct = document.querySelector(
        ".collection .collection-products .collection-product.col-0"
      );
      var splatContainer = createElement(
        "div",
        firstProduct.className + " " + splatItemClass
      );
      addSplatToContainer(
        splat,
        document.querySelector(".collection .collection-products > div"),
        splatContainer,
        splat.position
      );
      // redo index classes
      var productContainers = document.querySelectorAll(
        ".collection .collection-products .collection-product"
      );
      for (var i = 0; i < productContainers.length; i++) {
        removeClassFromElement(productContainers[i], "col-[0-9]{1,2}");
        productContainers[i].className =
          productContainers[i].className + " col-" + (i % 12);
      }
    },
  },
  // Mobilia & Responsive
  {
    useThisPattern: function () {
      return !!document.querySelector(".sixteen.columns .products .thumbnail");
    },
    addSplat: function (splat) {
      var firstProduct = document.querySelector(
        ".sixteen.columns .products .thumbnail"
      );
      var splatContainer = createElement(
        "div",
        firstProduct.className + " " + splatItemClass
      );
      var collectionContainer = document.querySelector(
        ".sixteen.columns .products"
      );
      addSplatToContainer(
        splat,
        collectionContainer,
        splatContainer,
        splat.position * 2
      );
      var numPerRow = Math.round(
        collectionContainer.clientWidth /
          elementWidthIncludingMargin(firstProduct)
      );
      var productContainers = document.querySelectorAll(
        ".sixteen.columns .products .thumbnail"
      );
      // remove clears
      removeMatchingChildren(collectionContainer, ".product_clear");
      // redo odd/even classes & clears
      for (var i = 0; i < productContainers.length; i++) {
        removeClassFromElement(productContainers[i], "(odd|even)");
        productContainers[i].className =
          productContainers[i].className + " " + (i % 2 == 0 ? "even" : "odd");
        if (i % numPerRow == numPerRow - 1) {
          collectionContainer.insertBefore(
            createElement("br", "clear product_clear"),
            productContainers[i].nextSibling
          );
        }
      }
    },
  },
  // Turbo
  {
    useThisPattern: function () {
      return !!document.querySelector(
        ".container .collection-matrix > .column .image__container"
      );
    },
    addSplat: function (splat) {
      var firstProduct = document.querySelector(".collection-matrix > .column");
      var splatContainer = createElement(
        "div",
        firstProduct.className + " " + splatItemClass
      );
      var collectionContainer = document.querySelector(".collection-matrix");
      // count how many clear divs offset the splat position
      var clearPositionOffset = 0;
      for (
        var i = 0;
        i <
        Math.min(
          collectionContainer.children.length,
          splat.position + clearPositionOffset
        );
        i++
      ) {
        if (collectionContainer.children[i].className.indexOf("clear") >= 0) {
          clearPositionOffset++;
        }
      }
      addSplatToContainer(
        splat,
        collectionContainer,
        splatContainer,
        splat.position + clearPositionOffset
      );
      // remove clears
      removeMatchingChildren(collectionContainer, ".product_clear");
      // redo layout classes & clears
      var numPerRow = Math.round(
        collectionContainer.clientWidth /
          elementWidthIncludingMargin(firstProduct)
      );
      var productContainers = document.querySelectorAll(
        ".collection-matrix > .column"
      );
      for (var i = 0; i < productContainers.length; i++) {
        removeClassFromElement(productContainers[i], "(alpha|omega|odd|even)");
        if (i % numPerRow == 0) {
          productContainers[i].className =
            productContainers[i].className + " alpha";
        }
        if (i % numPerRow == numPerRow - 1) {
          productContainers[i].className =
            productContainers[i].className + " omega";
        }
        if (i % 2 == 0) {
          productContainers[i].className =
            productContainers[i].className + " even";
        } else {
          productContainers[i].className =
            productContainers[i].className + " odd";
        }
        if (i % numPerRow == numPerRow - 1) {
          collectionContainer.insertBefore(
            createElement("br", "clear product_clear"),
            productContainers[i].nextSibling
          );
        }
      }
    },
  },
  // Envy
  {
    useThisPattern: function () {
      return !!document.querySelector("#Collection .product-grid .grid__item");
    },
    addSplat: function (splat) {
      var firstProduct = document.querySelector(
        "#Collection .product-grid .grid__item"
      );
      var splatContainer = createElement(
        "div",
        firstProduct.className + " " + splatItemClass
      );
      var collectionContainer = document.querySelector(
        "#Collection .product-grid"
      );
      addSplatToContainer(
        splat,
        collectionContainer,
        splatContainer,
        splat.position
      );
      // redo index classes
      var numPerRow = Math.round(
        collectionContainer.clientWidth /
          elementWidthIncludingMargin(firstProduct)
      );
      var productContainers = document.querySelectorAll(
        "#Collection .product-grid .grid__item"
      );
      for (var i = 0; i < productContainers.length; i++) {
        removeClassFromElement(productContainers[i], "(alpha|omega)");
        if (i % numPerRow == 0) {
          productContainers[i].className =
            productContainers[i].className + " alpha";
        }
        if (i % numPerRow == numPerRow - 1) {
          productContainers[i].className =
            productContainers[i].className + " omega";
        }
        if (i % 2 == 0) {
          productContainers[i].className =
            productContainers[i].className + " mobile-clear tablet-clear";
        }
      }
    },
  },
  // Brooklyn - collage
  {
    useThisPattern: function () {
      return !!document.querySelector(
        "#PageContainer .grid.grid-collage .grid__item.collage-grid__row"
      );
    },
    addSplat: function (splat) {
      var collectionContainer = document.querySelector(
        "#PageContainer .grid.grid-collage"
      );
      var splatContainer = createElement(
        "div",
        "grid__item push--large--one-third push--medium--one-third grid__item--small one-whole medium--one-third large--one-third " +
          splatItemClass
      );
      // insert on its own row
      addSplatToContainer(
        splat,
        collectionContainer,
        splatContainer,
        splat.position * 2 - 1
      );
    },
  },
  // Empire
  {
    useThisPattern: function () {
      return !!document.querySelector(".productgrid--items .productgrid--item");
    },
    addSplat: function (splat) {
      var collectionContainer = document.querySelector(".productgrid--items");
      var splatContainer = createElement(
        "div",
        "productgrid--item " + splatItemClass
      );
      addSplatToContainer(
        splat,
        collectionContainer,
        splatContainer,
        splat.position
      );
    },
  },
  // Loft
  {
    useThisPattern: function () {
      return !!document.querySelector(
        ".collection-products.grid__item .grid__item #dummy"
      );
    },
    addSplat: function (splat) {
      var splatContainer = attemptWithGenericPattern(splat);
      if (splatContainer) {
        // height must match neighbours exactly
        splatContainer.firstChild.id = "dummy";
        splatContainer.firstChild.style.height = 0;
        splatContainer.firstChild.querySelector("img").style.transform =
          "translate(0, -100%)";
      }
    },
  },
  // Impulse
  {
    useThisPattern: function () {
      return !!document.querySelector(".grid--collection .grid-product");
    },
    addSplat: function (splat) {
      var collectionContainer = document.querySelector(".grid--collection");
      var gridItemClasses = collectionContainer
        .querySelector(".grid-product")
        .className.replace("grid-product__has-quick-shop", "");
      var splatContainer = createElement(
        "div",
        gridItemClasses + " " + splatItemClass
      );
      addSplatToContainer(
        splat,
        collectionContainer,
        splatContainer,
        splat.position
      );
    },
  },
  // Motion & Debutify
  {
    useThisPattern: function () {
      return !!document.querySelector("#CollectionSection .grid");
    },
    addSplat: function (splat) {
      var collectionContainer = document.querySelector(
        "#CollectionSection .grid:last-child"
      );
      var existingProduct = document.querySelector(
        "#CollectionSection .grid-product"
      );
      var splatContainer = createElement(
        "div",
        existingProduct.className + " " + splatItemClass
      );
      addSplatToContainer(
        splat,
        collectionContainer,
        splatContainer,
        splat.position
      );
    },
  },
  // Basel wtih packery
  {
    useThisPattern: function () {
      return !!document.querySelector(".products.elements-grid");
    },
    addSplat: function (splat) {
      var collectionContainer = document.querySelector(
        ".products.elements-grid"
      );
      var existingProduct = document.querySelector(
        ".products.elements-grid .product-grid-item"
      );
      var splatContainer = createElement(
        "div",
        existingProduct.className + " " + splatItemClass
      );
      addSplatToContainer(
        splat,
        collectionContainer,
        splatContainer,
        splat.position
      );
      // remove clearfixes
      removeMatchingChildren(collectionContainer, ".clearfix");
      // redo clearfixes
      var productContainers =
        collectionContainer.querySelectorAll(".product-grid-item");
      for (var i = 1; i < productContainers.length; i++) {
        if (i % 2 == 1) {
          collectionContainer.insertBefore(
            createElement("div", "clearfix visible-xs-block"),
            productContainers[i].nextSibling
          );
        }
        if (i % 3 == 2) {
          collectionContainer.insertBefore(
            createElement("div", "clearfix visible-sm-block"),
            productContainers[i].nextSibling
          );
        }
        if (i % 4 == 3) {
          collectionContainer.insertBefore(
            createElement("div", "clearfix visible-md-block visible-lg-block"),
            productContainers[i].nextSibling
          );
        }
      }
      // packery plugin
      if (
        window.jQuery &&
        typeof jQuery(collectionContainer).data("packery") != "undefined"
      ) {
        jQuery(collectionContainer).packery("reloadItems");
        jQuery(collectionContainer).packery();
      }
    },
  },
  // Kagami
  {
    useThisPattern: function () {
      return !!document.querySelector(
        ".collection__grid .collection__grid-item"
      );
    },
    addSplat: function (splat) {
      var firstProduct = document.querySelector(
        ".collection__grid .collection__grid-item"
      );
      var splatContainer = createElement(
        "div",
        "collection__grid-item " + splatItemClass
      );
      var collectionContainer = document.querySelector(".collection__grid");
      addSplatToContainer(
        splat,
        collectionContainer,
        splatContainer,
        splat.position
      );

      // redo grid layout classes
      var productContainers = document.querySelectorAll(
        ".collection__grid .collection__grid-item"
      );

      var firstDesktopClassIndex = -1;
      var desktopClassRepeatInterval = 6;
      for (var i = 0; i < productContainers.length; i++) {
        if (
          productContainers[i].className.indexOf("grid__item--desktop-first") >
          -1
        ) {
          if (firstDesktopClassIndex > -1) {
            desktopClassRepeatInterval = i - firstDesktopClassIndex;
            break;
          } else {
            firstDesktopClassIndex = i;
          }
        }
      }

      for (var i = 0; i < productContainers.length; i++) {
        removeClassFromElement(
          productContainers[i],
          "(grid__item--mobile-first|grid__item--tablet-first|grid__item--desktop-first)"
        );
        if (i % 2 == 0) {
          productContainers[i].className =
            productContainers[i].className + " grid__item--mobile-first";
        }
        if (i % 3 == 0) {
          productContainers[i].className =
            productContainers[i].className + " grid__item--tablet-first";
        }
        if (i % firstDesktopClassIndex == 0) {
          productContainers[i].className =
            productContainers[i].className + " grid__item--desktop-first";
        }
      }
    },
  },
];

// helper functions
var createElement = function (type, classes) {
  var el = document.createElement(type);
  el.className = classes;
  return el;
};

var addSplatToContainerWithFirstLastClear = function (
  collectionContainerSelector,
  productContainersSelector,
  splatContainer,
  splat,
  firstClass,
  lastClass,
  clearElement
) {
  var collectionContainer = document.querySelector(collectionContainerSelector);
  var firstProduct = document.querySelector(productContainersSelector);
  // calculate number-per-row
  var numPerRow = Math.round(
    collectionContainer.clientWidth / elementWidthIncludingMargin(firstProduct)
  );
  // add the splat
  addSplatToContainer(
    splat,
    collectionContainer,
    splatContainer,
    splat.position
  );
  // remove clearing classes & elements
  var productContainers = document.querySelectorAll(productContainersSelector);
  for (var i = 0; i < productContainers.length; i++) {
    if (firstClass) {
      removeClassFromElement(productContainers[i], firstClass);
    }
    if (lastClass) {
      removeClassFromElement(productContainers[i], lastClass);
    }
  }
  if (clearElement) {
    var clearQuery = clearElement.nodeName.toLowerCase();
    if (clearElement.className) {
      clearQuery = clearQuery + "." + clearElement.className;
    }
    removeMatchingChildren(collectionContainer, clearQuery);
  }
  // add clearing classes & elements
  productContainers = document.querySelectorAll(productContainersSelector);
  for (var i = 0; i < productContainers.length; i++) {
    if (firstClass && i % numPerRow == 0) {
      productContainers[i].className =
        productContainers[i].className + " " + firstClass;
    }
    if (lastClass && i % numPerRow == numPerRow - 1) {
      productContainers[i].className =
        productContainers[i].className + " " + lastClass;
    }
    if (clearElement && i % numPerRow == numPerRow - 1) {
      var clearClone = clearElement.cloneNode();
      collectionContainer.insertBefore(
        clearClone,
        productContainers[i].nextSibling
      );
    }
  }
};

var removeMatchingChildren = function (container, selector) {
  var matching = container.querySelectorAll(selector);
  for (var i = 0; i < matching.length; i++) {
    if (matching[i].parentNode == container) {
      container.removeChild(matching[i]);
    }
  }
};

var addSplatAcrossMultipleContainers = function (
  collectionContainers,
  splatContainer,
  splat
) {
  // get containers
  var collectionIndex = (splat.position - 1) % collectionContainers.length;
  var verticalIndex =
    parseInt(Math.min((splat.position - 1) / collectionContainers.length)) + 1;
  // add the splat to the right container
  addSplatToContainer(
    splat,
    collectionContainers[collectionIndex],
    splatContainer,
    verticalIndex
  );
};

var removeClassFromElement = function (element, classToRemove) {
  element.className = element.className.replace(
    new RegExp("(?:^|\\s)" + classToRemove + "(?!\\S)", "g"),
    ""
  );
};

var elementWidthIncludingMargin = function (element) {
  var style = element.currentStyle || window.getComputedStyle(element);
  var width = element.offsetWidth;
  var margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);
  return width + margin;
};

var splatImageLoaded = function (url, node, callback) {
  var tImg = new Image();
  // local ref for callback
  var thisNode = node;
  tImg.onload = function () {
    callback(thisNode);
  };
  tImg.src = url;
  // hack to handle cached images
  if (tImg.complete || tImg.complete === undefined) {
    tImg.src =
      "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
    tImg.src = url;
  }
};

var nodeIsProductBlock = function (node) {
  // list item
  if (node.nodeName === "LI") {
    return true;
  }
  // previous sibling shares same class
  if (node.classList && node.classList.length) {
    if (
      node.previousElementSibling &&
      node.previousElementSibling.classList.length &&
      node.previousElementSibling.classList[0] == node.classList[0]
    ) {
      return true;
    }
  }
  return false;
};

var isProductImage = function (img) {
  var src = null;
  if (typeof img.srcset != "undefined" && img.srcset.length > 0) {
    src = img.srcset;
  } else if (
    typeof img.dataset != "undefined" &&
    typeof img.dataset.src != "undefined"
  ) {
    src = img.dataset.src;
  } else if (
    typeof img.dataset != "undefined" &&
    typeof img.dataset.bgset != "undefined"
  ) {
    src = img.dataset.bgset;
  } else if (
    typeof img.style != "undefined" &&
    typeof img.style.backgroundImage != "undefined"
  ) {
    src = img.style.backgroundImage;
  } else if (typeof img.src != "undefined" && img.src.length > 0) {
    src = img.src;
  }
  if (src && productImageRegex.test(src)) {
    return true;
  } else {
    return false;
  }
};

var checkSetMaxHeight = function (splatImage, collectionContainer) {
  var allImgs = collectionContainer.getElementsByTagName("img");
  var maxHeight = -1;

  // if a max-height exists on any product images, find the largest one
  for (var i = 0; i < allImgs.length; i++) {
    var img = allImgs[i];
    if (isProductImage(img)) {
      var computedStyle = window.getComputedStyle(img);
      var computedMaxHeight = computedStyle.getPropertyValue("max-height");
      if (
        computedMaxHeight &&
        computedMaxHeight != "none" &&
        computedMaxHeight.slice(-1) != "%"
      ) {
        intComputedMaxHeight = parseInt(computedMaxHeight);
        if (intComputedMaxHeight > maxHeight) {
          maxHeight = intComputedMaxHeight;
        }
      }
    }
  }
  // assign max-height
  splatImage.style.maxHeight = maxHeight > 0 ? maxHeight + "px" : "";
};

// cheers Remy
function debounce(fn, delay) {
  var timer = null;
  return function () {
    var context = this,
      args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
}

function isValidUrlForSplat(splat) {
  var splitPath = window.location.pathname.replace(/\/+$/, "").split("/");
  console.log(splat);
  
  if (
    //splat.type == "collection" &&
    (splitPath.length == 3 || splitPath.length == 4 || true) &&
    (splitPath[1] == "collections" || true) &&
    (splat.handle === "index"  || splat.handle == "" || // empty handle means 'all collections'
      splitPath[2] == splat.handle)
  ) {
    //console.log("1");
    // correct url/collection, now check if filtered by tag
    if (splitPath.length == 4 && !splat.show_on_tag_filtered_pages) {
      //console.log("2");
      return false;
    } else if (splitPath.length == 1 ) {
      // Startseite
      //console.log("startseite");
      //console.log("splat.type: "+splat.type);
        //console.log(splat.type === "index");
      if(splat.type === "index") {
        
        //console.log("return true");
        return true;
      }else{
        //console.log("return false");
        return false;
      }
    } else if (splat.type === "index" ) {
      // Startseite
      //console.log("index");
      //console.log("splat.type: "+splat.type);
        //console.log(splat.type === "index");
      if(splitPath.length == 1) {       
        //console.log("return true");
        return true;
      }else{
        //console.log("return false");
        return false;
      }
    } else if (splat.show_on_all_pages) {
      //console.log("3");
      // showing on all pages of this collection
      return true;
    } else {
      // check we're on the first page of this collection
      //console.log("4");
      var pageQueryMatch = window.location.search.match(/[?&](page=([0-9]*))/);
      var currentPage = 1;
      if (pageQueryMatch && pageQueryMatch.length == 3) {
        currentPage = parseInt(pageQueryMatch[2]);
      }
      if (currentPage == 1) {
        return true;
      }
    }
  }
  return false;
}

function addSplatToContainer(
  splat,
  collectionContainer,
  splatContainer,
  position,
  onload,
  immediately
) {
  // add link
  var linkOpen;
  var linkClose;
  if (splat.link) {
    linkOpen = '<a href="' + splat.link + '">';
    linkClose = "</a>";
  } else {
    linkOpen = "";
    linkClose = "";
  }

  // insert ad into container
  var ad_html = [
    '<div style="text-align:center">',
    linkOpen,
    '<img src="',
    splat.url,
    '" alt="adquick" style="opacity:1!important; max-width:100%; vertical-align:top" loading="lazy">',
    linkClose,
    "</div>",
  ].join("");
  splatContainer.innerHTML = splatContainer.innerHTML + ad_html;

  // insert it
  if (collectionContainer.childElementCount >= position) {
    collectionContainer.insertBefore(
      splatContainer,
      collectionContainer.children[position - 1]
    );
  } else {
    collectionContainer.appendChild(splatContainer);
  }

  if (immediately) {
    immediately(splatContainer);
  }

  if (onload) {
    splatImageLoaded(splat.url, splatContainer, onload);
  }
}

function isRecentlyViewedImage(img) {
  // assume 'recently' is in the class name of a parent of the image
  var elem = img;
  while (elem !== document.body) {
    if (elem.className.indexOf("recently") > -1) return true;
    elem = elem.parentElement;
  }
  return false;
}

function attemptWithGenericPattern(splat) {
  var collectionContainer = null;
  var productContainer = null;
  var productImage = null;

  // check each product image on page, starting with the last
  var allImgs = document.querySelectorAll(
    'img[src*="/products/"], img[srcset*="/products/"], img[data-src*="/products/"], [style*="/products/"], [data-bgset*="/products/"]'
  );
  for (var i = allImgs.length - 1; i >= 0; i--) {
    if (isProductImage(allImgs[i]) && !isRecentlyViewedImage(allImgs[i])) {
      productImage = allImgs[i];
      break;
    }
  }

  // see if this image is part of a product block, and has a recognisable collection container
  if (productImage) {
    // locate the parent
    var node = productImage.parentNode;
    while (!productContainer && node) {
      if (nodeIsProductBlock(node)) {
        productContainer = node;
        collectionContainer = node.parentNode;
      } else {
        // traverse up
        node = node.parentNode;
      }
    }
  }

  if (collectionContainer && productContainer) {
    var newNode = productContainer.cloneNode();
    newNode.innerHTML = "";
    newNode.className = newNode.className + " " + splatItemClass;

    // hide until loaded & positioned
    newNode.style.opacity = 0;

    addSplatToContainer(
      splat,
      collectionContainer,
      newNode,
      splat.position,
      function (node) {
        // for reference in callbacks
        var _node = node;

        // show now
        _node.style.opacity = 1;

        // check for height limit again on resize event
        window.addEventListener(
          "resize",
          debounce(function () {
            checkSetMaxHeight(
              _node.getElementsByTagName("img")[0],
              collectionContainer
            );
          }, 250)
        );

        // send a resize event - many themes assess layout on resize
        window.dispatchEvent(new Event("resize"));

        // theme-specific reflow
        // masonry plugin
        function runMasonry(jq) {
          if (
            jq &&
            jq(collectionContainer).masonry &&
            typeof jq(collectionContainer).data("masonry") != "undefined"
          ) {
            jq(collectionContainer).masonry("reloadItems");
            jq(collectionContainer).masonry();
            return true;
          }
          return false;
        }
        runMasonry(window.j223) || // Cascade theme stores the theme's jQuery here
          runMasonry(window.jQuery); // Generic jQuery

        // packery plugin
        if (
          window.jQuery &&
          typeof jQuery(collectionContainer).data("packery") != "undefined"
        ) {
          jQuery(collectionContainer).packery("reloadItems");
          jQuery(collectionContainer).packery();
        }
      },
      function (node) {
        // check for product image height limits immediately
        checkSetMaxHeight(
          node.getElementsByTagName("img")[0],
          collectionContainer
        );
      }
    );

    return newNode;
  }
  return false;
}

function addSplats() {
  console.log("run addSplats");
  // remove existing
  var existingSplats = document.querySelectorAll("." + splatItemClass);
  for (var i = 0; i < existingSplats.length; i++) {
    existingSplats[i].parentElement.removeChild(existingSplats[i]);
  }

  // go through each splat
  for (var splatIndex = 0; splatIndex < splats.length; splatIndex++) {
    var splat = splats[splatIndex];

    // specific collection page only
    if (isValidUrlForSplat(splat)) {
      // check known theme patterns
      var usedKnownPattern = false;
      for (var i = 0; i < knownImplementationPatterns.length; i++) {
        if (knownImplementationPatterns[i].useThisPattern()) {
          knownImplementationPatterns[i].addSplat(splat);
          usedKnownPattern = true;
          break;
        }
      }
      //console.log("usedKnownPattern: " + usedKnownPattern);
      // attempt with generic pattern
      if (!usedKnownPattern) {
        attemptWithGenericPattern(splat);
      }
    }
  }
}

// run now
addSplats();
// run when section reloads
document.addEventListener("shopify:section:load", addSplats);

console.log("load adquick");
